import api from './api';
import {
  Order,
  OrderListResponse,
  CreateOrderRequest,
  CreateOrderResponse,
  PaginationParams,
  OrderDetailResponse
} from '../types/api';

type ApiSuccessResponse<T> = {
  success?: boolean;
  data: T;
};

/**
 * Serviço de Pedidos
 */
const orderService = {
  /**
   * Lista pedidos do usuário
   */
  async list(params?: {
    status?: string;
  } & PaginationParams): Promise<OrderListResponse> {
    const response = await api.get<ApiSuccessResponse<OrderListResponse>>(
      '/orders',
      { params }
    );
    return response.data.data;
  },

  /**
   * Retorna detalhes de um pedido específico
   */
  async getById(id: string): Promise<{ order: Order }> {
    const response = await api.get<ApiSuccessResponse<OrderDetailResponse>>(
      `/orders/${id}`
    );
    return response.data.data;
  },

  /**
   * Cria um novo pedido
   */
  async create(data: CreateOrderRequest): Promise<CreateOrderResponse> {
    const response = await api.post<ApiSuccessResponse<CreateOrderResponse>>(
      '/orders',
      data
    );
    return response.data.data;
  },

  /**
   * Atualiza status de um pedido (Admin)
   */
  async updateStatus(
    id: string,
    data: {
      status: string;
      trackingCode?: string;
    }
  ): Promise<{ order: Order }> {
    const response = await api.put<ApiSuccessResponse<{ order: Order }>>(
      `/orders/${id}/status`,
      data
    );
    return response.data.data;
  },

  /**
   * Cancela um pedido
   */
  async cancel(id: string): Promise<{ order: Order; refundInfo: unknown }> {
    const response = await api.post<
      ApiSuccessResponse<{ order: Order; refundInfo: unknown }>
    >(`/orders/${id}/cancel`);
    return response.data.data;
  },
};

export default orderService;

